import { CashFlowVisualizationConfig } from '@/lib/platform/types/cash-flow';

export const defaultConfig: CashFlowVisualizationConfig = {
  chartType: 'sankey',
  height: 500,
  colorScheme: 'default',
  showLegend: true,
  showTooltips: true,
  showLabels: true,
  position: 'before-sales',
  animationDuration: 300,
  enableInteractivity: true,
};
